export default __webpack_public_path__ + "static/media/survey2.67055261.svg";